// extracted by mini-css-extract-plugin
module.exports = {"bonus":"BonusPanel-BonusPanel-bonus-3gIhvnjO"};